<!-- 国际流量卡运营商套餐信息 -->
<template>
  <div>
    <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
      <el-form-item prop="continent">
        <el-input v-model="queryParams.orderId"  placeholder="运营商订单号" clearable style="width: 210px" @keyup.enter.native="search" />
      </el-form-item>
      <el-button type="primary" icon="el-icon-search"  @click="search">搜索</el-button>
       <el-button type="primary" icon="el-icon-refresh"  @click="syncPackages">同步套餐</el-button>
    </el-form>
    <el-table :data="tableServerInfo" border>
      <el-table-column type="index" label="序号" align="center" width="60px"></el-table-column>
      <el-table-column label="运营商订单号" align="center" width="220">
        <template slot-scope="{row}">
          <div> {{ row.orderId || '-' }}</div>
          <div  style="color: #8c8c8c;"> {{ row.orderNum || '-' }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="productName" label="套餐名" align="center" width="260" :show-overflow-tooltip="true">
        <template slot-scope="{row}">
          <div> {{ row.productName || '-' }}</div>
          <div  style="color: #8c8c8c;"> {{ row.dataBundleId || '-' }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="type" label="类型" v-if="channel == 'Quadcell'" align="center" width="260" :show-overflow-tooltip="true">
        <template slot-scope="{row}">
          <el-tag type="primary" v-if="row.type == '1'">套餐</el-tag>
          <el-tag type="info" v-else-if="row.type == '2'">文件</el-tag>
          <el-tag type="info" v-else>未知</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="remainFlow" label="剩余流量(M)" align="center" v-if="adminShow" width="120"></el-table-column>
      <el-table-column prop="monthFlow" label="总流量(M)" align="center" v-if="channel != 'Quadcell'"></el-table-column>
      <el-table-column prop="totalFlow" label="总流量(M)" align="center" v-if="channel == 'Quadcell'"></el-table-column>
      <el-table-column prop="status" v-if="adminShow" label="套餐状态" align="center" >
        <template slot-scope="scope">
          <span v-if="scope.row.status == '1'" style="color: #1890ff;">待激活</span>
          <span v-else-if="scope.row.status == '2'" style="color: #52c41a;">正使用</span>
          <span v-else-if="scope.row.status == '3'" style="color: #8c8c8c;">已使用</span>
          <span v-else-if="scope.row.status == '99'" style="color: #722ed1;">已退订</span>
          <span v-else-if="scope.row.status == '5'" style="color: #E6A23C;">已删除</span>
          <span v-else>未知</span>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建/最晚激活时间" align="center" width="220" v-if="channel != 'Quadcell'">

        <template slot-scope="{row}">
          <div> {{ row.createTime || '-' }}</div>
          <div  style="color: #8c8c8c;"> {{ row.endTime || '-' }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="activeTime" label="开始/过期时间" align="center" width="220">
        <template slot-scope="{row}">
          <div> {{ row.activeTime || '-' }}</div>
          <div  style="color: #8c8c8c;"> {{ row.expireTime || '-' }}</div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { internationalCardProductExternal , syncInternationalCardProductExternal } from "@/api/international.js"; //国际运营商列表

export default {
  props: {
    iccid: {
      type: [String]
    },
    channel: {
      type: [String]
    },

  },
  data() {
    return{
      tableServerInfo:[],
      queryParams:{
        orderId:undefined
      }
    }
  },
  computed: {
    adminShow(){
      return this.$store.getters.user.userType =='1'
    },
  },
  watch: {
    iccid() {
      this.initData();
    }
  },
  methods: {
    // 获取列表的数据
    initData(){
      let iccid = this.iccid;
      let orderId = this.queryParams.orderId;
      internationalCardProductExternal({iccid,orderId}).then(res => {
        this.tableServerInfo = res.data.data;
      })
    },
    search(){
      this.initData();
    },
    syncPackages(){
      let iccid = this.iccid;
      syncInternationalCardProductExternal({iccid}).then(res=>{
        this.$message({
          message: '同步成功',
          type: 'success'
        })
        this.initData()
      })
    }
  },
  created() {
   this.initData();
  }
};
</script>

<style scoped lang="less">
::v-deep .highlight-row {
  background-color: #f0f9eb !important; /* 浅绿色背景 */
}
.product-list{
  display: flex; /* 或者 inline-flex */
  flex-wrap: wrap; /* 允许元素在需要时换行 */
  width: 160px;
  color: #409eff;
  .product-item{
    border: 1px solid #dcdfe6;
    width: 80px; /* 设置子元素的宽度 */
    white-space: nowrap;
    overflow: hidden; /* 隐藏超出容器的文本 */
    text-overflow: ellipsis; /* 使用省略号表示文本被截断 */
    height: 30px; /* 设置子元素的高度 */
    margin: 5px; /* 设置子元素的外边距 */
    background: #ecf5ff; /* 设置背景颜色 */
    line-height: 30px;
    align-content: flex-start;
    border-color: #b3d8ff;
    border-radius: 6px;
  }
  .el-dropdown-link{
    cursor: pointer;
    color: #409EFF;
    margin-left: 5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 30px;
    margin: 5px;
    line-height: 30px;
    -ms-flex-line-pack: start;
    align-content: flex-start;

  }
}
</style>


